import { Component } from 'react'
import { connect } from 'react-redux'

import { selectObjects } from '../../../../ducks/editor/objects'

class DraggableIndicator extends Component {
  handleAutoChange = () => {
    window.setTimeout(() => {
      const { appId, component, objects, onChangeComponent } = this.props

      if (!component && objects.length > 0) {
        onChangeComponent(appId, objects[0].id)
      }
    }, 50)
  }

  render() {
    const { component, objects } = this.props

    if (!component && objects.length > 0) {
      this.handleAutoChange()
    }

    return null
  }
}

const mapStateToProps = (state, { type }) => ({
  allComponents: selectObjects(state),
})

export default connect(mapStateToProps)(DraggableIndicator)
